// File created by Reginald Sahil Chand on 26-03-2024.

import React, {type ReactElement} from 'react';
import {MdMenu} from 'react-icons/md';

import {Logo} from '../logo/Logo';
import {Button} from '../../button/Button';

/**
 * @author Reginald Sahil Chand
 * @email Developer.ReginaldSahilChand@gmail.com
 *
 * @version 0.1.0
 *
 * @property {boolean} taskNavigationDrawerState - Boolean value to toggle a drawer based on its state.
 * @property {void} taskNavigationDrawerFunction - Void function to actually change the taskNavigationDrawerState onclick.
 */
type HeaderProps = {
	taskNavigationDrawerState: boolean;
	taskNavigationDrawerFunction: () => void;
};

/**
 * @author Reginald Sahil Chand
 * @email Developer.ReginaldSahilChand@gmail.com
 *
 * @description Renders the header with a logo and a hamburger menu (Buttons component) to open and close the TaskNavigation.
 *
 * @type {HeaderProps} These are the parameters required for this component.
 * @version 0.1.0
 *
 * @returns {JSX Element} Header component.
 */
export const Header: React.FC<HeaderProps> = React.memo(
	({taskNavigationDrawerState, taskNavigationDrawerFunction}: HeaderProps): ReactElement => {
		return (
			<header className="p-5 flex items-center justify-between bg-header md:col-span-2">
				<Logo logoText="Task Quazar" />
				<div className="md:hidden">
					<Button
						buttonIcon={<MdMenu />}
						buttonDescription={
							taskNavigationDrawerState
								? 'Close task navigation drawer.'
								: 'Open task navigation drawer.'
						}
						buttonFunction={taskNavigationDrawerFunction}
					/>
				</div>
			</header>
		);
	},
);

Header.displayName = 'Header';
